import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { BoostIcon } from 'src/svgs/BoostIcon';
import { BoostIconLight } from 'src/svgs/BoostIconLight';
import { PosIconProps } from 'src/svgs/SvgWrapper';

export const BoostIconDisplay = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    isSelected?: boolean;
    inactive?: boolean;
  }
) => {
  const { isDarkMode } = useSiteTheme();

  return props.isSelected ? (
    <BoostIconLight
      {...props}
      inactive={props.inactive}
      activeFill={
        isDarkMode ? vars.color.surfacePrimary : vars.color.iconPrimaryInverted
      }
    />
  ) : (
    <BoostIcon {...props} inactive={props.inactive} />
  );
};
